import { render, staticRenderFns } from "./ThemeDetailSlider.vue?vue&type=template&id=faa0f8e4&scoped=true&"
import script from "./ThemeDetailSlider.vue?vue&type=script&lang=js&"
export * from "./ThemeDetailSlider.vue?vue&type=script&lang=js&"
import style0 from "./ThemeDetailSlider.vue?vue&type=style&index=0&id=faa0f8e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa0f8e4",
  null
  
)

export default component.exports